import { useEffect } from "react";

type Options = {
  enabled: boolean;
  thresholdPx: number;
};

export function useMouseTopTrigger(
  open: () => void,
  { enabled, thresholdPx }: Options,
) {
  useEffect(() => {
    if (!enabled) return;
    if (!window.matchMedia("(pointer: fine)").matches) return;

    const handler = (e: MouseEvent) => {
      if (e.clientY <= thresholdPx) {
        open();
        document.removeEventListener("mousemove", handler);
      }
    };

    document.addEventListener("mousemove", handler);
    return () => document.removeEventListener("mousemove", handler);
  }, [open, enabled, thresholdPx]);
}
